/**
 * TanStack Query hooks for `link-test`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	linkTestQueryKeys,
	type CreateLinkTestBody,
	type ListLinkTestResponse,
	type LinkTestRow,
} from "./api";

export function useLinkTestList(): UseQueryResult<ListLinkTestResponse, Error> {
	return useQuery({
		queryKey: linkTestQueryKeys.list(),
		queryFn: list,
	});
}

export function useLinkTestCreate(): UseMutationResult<LinkTestRow, Error, CreateLinkTestBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkTestQueryKeys.all });
		},
	});
}

export function useLinkTestDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkTestQueryKeys.all });
		},
	});
}
